import { BinaryReader } from "../../../binary";
import { createProtobufRpcClient } from "@cosmjs/stargate";
import { QueryParamsRequest, QueryParamsResponse, QueryProvidersRequest, QueryProvidersResponse, QueryProviderRequest, QueryProviderResponse, QueryGetPairingRequest, QueryGetPairingResponse, QueryVerifyPairingRequest, QueryVerifyPairingResponse, QueryProviderPairingChanceRequest, QueryProviderPairingChanceResponse, QueryUserEntryRequest, QueryUserEntryResponse, QueryStaticProvidersListRequest, QueryStaticProvidersListResponse, QueryEffectivePolicyRequest, QueryEffectivePolicyResponse, QueryProviderMonthlyPayoutRequest, QueryProviderMonthlyPayoutResponse, QuerySubscriptionMonthlyPayoutRequest, QuerySubscriptionMonthlyPayoutResponse, QuerySdkPairingResponse, QueryProvidersEpochCuRequest, QueryProvidersEpochCuResponse } from "./query";
export class QueryClientImpl {
    rpc;
    constructor(rpc) {
        this.rpc = rpc;
        this.params = this.params.bind(this);
        this.providers = this.providers.bind(this);
        this.provider = this.provider.bind(this);
        this.getPairing = this.getPairing.bind(this);
        this.verifyPairing = this.verifyPairing.bind(this);
        this.providerPairingChance = this.providerPairingChance.bind(this);
        this.userEntry = this.userEntry.bind(this);
        this.staticProvidersList = this.staticProvidersList.bind(this);
        this.effectivePolicy = this.effectivePolicy.bind(this);
        this.providerMonthlyPayout = this.providerMonthlyPayout.bind(this);
        this.subscriptionMonthlyPayout = this.subscriptionMonthlyPayout.bind(this);
        this.sdkPairing = this.sdkPairing.bind(this);
        this.providersEpochCu = this.providersEpochCu.bind(this);
    }
    params(request = {}) {
        const data = QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("lavanet.lava.pairing.Query", "Params", data);
        return promise.then(data => QueryParamsResponse.decode(new BinaryReader(data)));
    }
    providers(request) {
        const data = QueryProvidersRequest.encode(request).finish();
        const promise = this.rpc.request("lavanet.lava.pairing.Query", "Providers", data);
        return promise.then(data => QueryProvidersResponse.decode(new BinaryReader(data)));
    }
    provider(request) {
        const data = QueryProviderRequest.encode(request).finish();
        const promise = this.rpc.request("lavanet.lava.pairing.Query", "Provider", data);
        return promise.then(data => QueryProviderResponse.decode(new BinaryReader(data)));
    }
    getPairing(request) {
        const data = QueryGetPairingRequest.encode(request).finish();
        const promise = this.rpc.request("lavanet.lava.pairing.Query", "GetPairing", data);
        return promise.then(data => QueryGetPairingResponse.decode(new BinaryReader(data)));
    }
    verifyPairing(request) {
        const data = QueryVerifyPairingRequest.encode(request).finish();
        const promise = this.rpc.request("lavanet.lava.pairing.Query", "VerifyPairing", data);
        return promise.then(data => QueryVerifyPairingResponse.decode(new BinaryReader(data)));
    }
    providerPairingChance(request) {
        const data = QueryProviderPairingChanceRequest.encode(request).finish();
        const promise = this.rpc.request("lavanet.lava.pairing.Query", "ProviderPairingChance", data);
        return promise.then(data => QueryProviderPairingChanceResponse.decode(new BinaryReader(data)));
    }
    userEntry(request) {
        const data = QueryUserEntryRequest.encode(request).finish();
        const promise = this.rpc.request("lavanet.lava.pairing.Query", "UserEntry", data);
        return promise.then(data => QueryUserEntryResponse.decode(new BinaryReader(data)));
    }
    staticProvidersList(request) {
        const data = QueryStaticProvidersListRequest.encode(request).finish();
        const promise = this.rpc.request("lavanet.lava.pairing.Query", "StaticProvidersList", data);
        return promise.then(data => QueryStaticProvidersListResponse.decode(new BinaryReader(data)));
    }
    effectivePolicy(request) {
        const data = QueryEffectivePolicyRequest.encode(request).finish();
        const promise = this.rpc.request("lavanet.lava.pairing.Query", "EffectivePolicy", data);
        return promise.then(data => QueryEffectivePolicyResponse.decode(new BinaryReader(data)));
    }
    providerMonthlyPayout(request) {
        const data = QueryProviderMonthlyPayoutRequest.encode(request).finish();
        const promise = this.rpc.request("lavanet.lava.pairing.Query", "ProviderMonthlyPayout", data);
        return promise.then(data => QueryProviderMonthlyPayoutResponse.decode(new BinaryReader(data)));
    }
    subscriptionMonthlyPayout(request) {
        const data = QuerySubscriptionMonthlyPayoutRequest.encode(request).finish();
        const promise = this.rpc.request("lavanet.lava.pairing.Query", "SubscriptionMonthlyPayout", data);
        return promise.then(data => QuerySubscriptionMonthlyPayoutResponse.decode(new BinaryReader(data)));
    }
    sdkPairing(request) {
        const data = QueryGetPairingRequest.encode(request).finish();
        const promise = this.rpc.request("lavanet.lava.pairing.Query", "SdkPairing", data);
        return promise.then(data => QuerySdkPairingResponse.decode(new BinaryReader(data)));
    }
    providersEpochCu(request = {}) {
        const data = QueryProvidersEpochCuRequest.encode(request).finish();
        const promise = this.rpc.request("lavanet.lava.pairing.Query", "ProvidersEpochCu", data);
        return promise.then(data => QueryProvidersEpochCuResponse.decode(new BinaryReader(data)));
    }
}
export const createRpcQueryExtension = (base) => {
    const rpc = createProtobufRpcClient(base);
    const queryService = new QueryClientImpl(rpc);
    return {
        params(request) {
            return queryService.params(request);
        },
        providers(request) {
            return queryService.providers(request);
        },
        provider(request) {
            return queryService.provider(request);
        },
        getPairing(request) {
            return queryService.getPairing(request);
        },
        verifyPairing(request) {
            return queryService.verifyPairing(request);
        },
        providerPairingChance(request) {
            return queryService.providerPairingChance(request);
        },
        userEntry(request) {
            return queryService.userEntry(request);
        },
        staticProvidersList(request) {
            return queryService.staticProvidersList(request);
        },
        effectivePolicy(request) {
            return queryService.effectivePolicy(request);
        },
        providerMonthlyPayout(request) {
            return queryService.providerMonthlyPayout(request);
        },
        subscriptionMonthlyPayout(request) {
            return queryService.subscriptionMonthlyPayout(request);
        },
        sdkPairing(request) {
            return queryService.sdkPairing(request);
        },
        providersEpochCu(request) {
            return queryService.providersEpochCu(request);
        }
    };
};
